import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-administracion-empresa-transporte',
  templateUrl: './administracion-empresa-transporte.component.html',
  styleUrls: ['./administracion-empresa-transporte.component.css']
})
export class AdministracionEmpresaTransporteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
